export enum PoSystemStatusEnum {
    New = 1,
    Submitted = 2,
    Expired = 3,
    With_Supplier = 4,
    Completed = 5
}

export enum PoSystemStatusNameValueEnum {
  New = 'New',
  Submitted = 'Submitted',
  Expired = 'Expired',
  With_Supplier = 'With Supplier',
  Completed = 'Completed'
}

export enum PoSystemStatusTypeNameValueEnum {
  New = 'orderNewStatus',
  Submitted = 'orderSubmittedStatus',
  Expired = 'orderExpiredStatus',
  With_Supplier = 'orderWithSupplierStatus',
  Completed = 'orderCompletedStatus'
}